import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of, tap, share, finalize } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class NewRequestService {
  apiUrl = environment.apiUrl;
  _addNewBrokerRequest = this.apiUrl + '/addNewBrokerRequest';
  _searchBrokerRequest = this.apiUrl + '/searchBrokerRequests';
  _updateBrokerRequest = this.apiUrl + '/updateBrokerRequest';
  _deleteRequest = this.apiUrl + '/archiveRequest'
  _getBrokerDetails = this.apiUrl + '/getBrokerDetailsById'
  getallEvents = this.apiUrl + '/getEvents';
  getBrokerRequestCompanies = this.apiUrl + '/getBrokerRequestCompanies';
  _indicativeQuote = this.apiUrl + '/createIndicativeQuote';
  _brokerQuote = this.apiUrl + '/createBrokerQuote';
  _bindQuote = this.apiUrl + '/bindQuote';
  _checkCapacity = this.apiUrl + '/getBinderCapacity';
  _requestCustomisedPrice = this.apiUrl + '/requestCustomisedPrice';
  _getSupportedCountry = this.apiUrl + '/getSupportedCountry';
  _getUsStatesData  = this.apiUrl + '/getUsStatesData';
  _restoreRequest = this.apiUrl + '/restoreRequest';
  _regenerateRequest = this.apiUrl + '/regenerateRequest';
  _getSubTypes = this.apiUrl + '/getSubTypes';
  _getPremiumStructure = this.apiUrl + '/getPremiumAmount';
  _downloadPolicy = this.apiUrl + '/downloadBrokerPolicy';
  _getHistoricEventsData = this.apiUrl + '/getHistoricEventsData';
  _getAgentsData = this.apiUrl + '/getCalculationAgents';
  _getBrokerClients = this.apiUrl + '/getBrokerClients';
  _addBrokerClient = this.apiUrl + '/addBrokerClient ';
  _updateBrokerClient = this.apiUrl + "/updateBrokerClient" 
  _getBrokerRequestInfo = this.apiUrl + "/getBrokerRequestInfo";
  _getInsurerClients = this.apiUrl + '/getInsurerClients';
  _addInsurerClient = this.apiUrl + '/addInsurerClient';
  _updateInsurerClient = this.apiUrl + '/updateInsurerClient';

  token: any;
  header: any;
  _checkReservations = this.apiUrl + '/checkReservations';
  cache: any;
  cachedObservable: any;

  constructor(
    private http: HttpClient
  ) { }

  newRequest(data: any) {
    this.token = localStorage.getItem('token');
    this.header = new HttpHeaders({
      Authorization: 'Bearer ' + this.token,
      Accept: '*/*',
    });
    return this.http.post(this._addNewBrokerRequest, data, { headers: this.header });
  }

  getSubTypes() {
    return this.http.get(this._getSubTypes);
  }

  searchBrokerRequest(id: any, data: any) {
    this.token = localStorage.getItem('token');
    this.header = new HttpHeaders({
      Authorization: 'Bearer ' + this.token,
      Accept: '*/*',
    });
    return this.http.post(this._searchBrokerRequest + '/' + id, data, { headers: this.header })
  }

  updateBrokerRequest(data: any, id: any, mode : any) {
    this.token = localStorage.getItem('token');
    this.header = new HttpHeaders({
      Authorization: 'Bearer ' + this.token,
      Accept: '*/*',
    });
    return this.http.patch(this._updateBrokerRequest + '/' + id + '/' + mode, data, { headers: this.header });
  }

  getEvents() {
    let observable: Observable<any>;
    if (this.cache) {
      observable = of(this.cache);
    }

    else if (this.cachedObservable) {
      observable = this.cachedObservable;
    }
    else {
      this.cachedObservable = this.http.get(this.getallEvents).pipe(
        tap(res => this.cache = res),
        share(),
        finalize(() => this.cachedObservable = null)
      );
      observable = this.cachedObservable;
    }
    return observable;
  }

  getCompanies(id) {
    this.token = localStorage.getItem('token');
    this.header = new HttpHeaders({
      Authorization: 'Bearer ' + this.token,
      Accept: '*/*',
    });
    return this.http.get(this.getBrokerRequestCompanies + '/' + id, { headers: this.header });
  }

  getBrokerDetails(id: any) {
    this.token = localStorage.getItem('token');
    this.header = new HttpHeaders({
      Authorization: 'Bearer ' + this.token,
      Accept: '*/*',
    });
    return this.http.get(this._getBrokerDetails + '/' + id, { headers: this.header })
  }

  deleteBrokerRequest(id: any) {
    this.token = localStorage.getItem('token');
    this.header = new HttpHeaders({
      Authorization: 'Bearer ' + this.token,
      Accept: '*/*',
    });
    return this.http.patch(this._deleteRequest + '/' + id, {}, { headers: this.header });
  }

  regenerateBrokerRequest(id: any) {
    this.token = localStorage.getItem('token');
    this.header = new HttpHeaders({
      Authorization: 'Bearer ' + this.token,
      Accept: '*/*',
    });
    return this.http.post(this._regenerateRequest + '/' + id, {}, { headers: this.header });
  }

  restoreRequest(id: any) {
    this.token = localStorage.getItem('token');
    this.header = new HttpHeaders({
      Authorization: 'Bearer ' + this.token,
      Accept: '*/*',
    });
    return this.http.patch(this._restoreRequest + '/' + id, {}, { headers: this.header });
  }

  indicativeQuote(data: any) {
    this.token = localStorage.getItem('token');
    this.header = new HttpHeaders({
      Authorization: 'Bearer ' + this.token,
      Accept: '*/*',
    });
    return this.http.post(this._indicativeQuote, data, { headers: this.header });
  }

  brokerQuote(id: any) {
    this.token = localStorage.getItem('token');
    this.header = new HttpHeaders({
      Authorization: 'Bearer ' + this.token,
      Accept: '*/*',
    });
    return this.http.post(this._brokerQuote + '/' + id, {}, { headers: this.header });
  }

  bindQuote(id: any) {
    this.token = localStorage.getItem('token');
    this.header = new HttpHeaders({
      Authorization: 'Bearer ' + this.token,
      Accept: '*/*',
    });
    return this.http.post(this._bindQuote + '/' + id, {}, { headers: this.header });
  }

  checkCapacity(id: any) {
    this.token = localStorage.getItem('token');
    this.header = new HttpHeaders({
      Authorization: 'Bearer ' + this.token,
      Accept: '*/*',
    });
    return this.http.post(this._checkCapacity + '/' + id, {}, { headers: this.header });
  }

  requestCustomisedPrice(data: any) {
    this.token = localStorage.getItem('token');
    this.header = new HttpHeaders({
      Authorization: 'Bearer ' + this.token,
      Accept: '*/*',
    });
    return this.http.post(this._requestCustomisedPrice, data, { headers: this.header });
  }

  getSupportedCountry() {
    return this.http.get(this._getSupportedCountry);
  }
  
  getUsStatesData(){
    return this.http.get(this._getUsStatesData);
  }

  getPrice(data) {
    this.token = localStorage.getItem('token');
    this.header = new HttpHeaders({
      Authorization: 'Bearer ' + this.token,
      Accept: '*/*',
    });
    return this.http.post(this._getPremiumStructure, data, { headers: this.header })
  }

  downloadPolicyData(id: any) {
    this.token = localStorage.getItem('token');
    this.header = new HttpHeaders({
      Authorization: 'Bearer ' + this.token,
      Accept: '*/*',
    });
    return this.http.post(this._downloadPolicy + '/' + id, {}, { headers: this.header });
  }

  getHistoricEvents(data: any) {
    this.token = localStorage.getItem('token');
    this.header = new HttpHeaders({
      Authorization: 'Bearer ' + this.token,
      Accept: '*/*',
    });
    return this.http.post(this._getHistoricEventsData, data, { headers: this.header });
  }

  getAgentsData() {
    return this.http.get(this._getAgentsData);
  }

  getBrokerClient(id: any) {
    this.token = localStorage.getItem('token');
    this.header = new HttpHeaders({
      Authorization: 'Bearer ' + this.token,
      Accept: '*/*',
    });
    return this.http.get(this._getBrokerClients + '/' + id, { headers: this.header })
  }

  addBrokerClient(clientData) {
    this.token = localStorage.getItem('token');
    this.header = new HttpHeaders({
      Authorization: 'Bearer ' + this.token,
      Accept: '*/*',
    });
    return this.http.post(this._addBrokerClient, clientData, { headers: this.header });
  }

  checkReservations(id: any){
    this.token = localStorage.getItem('token');
    this.header = new HttpHeaders({
      Authorization: 'Bearer ' + this.token,
      Accept: '*/*',
    });
    return this.http.post(this._checkReservations + '/' + id, {}, { headers: this.header });
  }

  updateBrokerClient(id:any, data:any){
    this.token = localStorage.getItem('token');
    this.header = new HttpHeaders({
      Authorization: 'Bearer ' + this.token,
      Accept: '*/*',
    });
    return this.http.patch(this._updateBrokerClient + '/' + id, data, { headers: this.header });
  }

  getQuoteReferralData(id:any , id2:any){
    this.token = localStorage.getItem('token');
    this.header = new HttpHeaders({
      Authorization: 'Bearer ' + this.token,
      Accept: '*/*',
    });
    return this.http.get(this._getBrokerRequestInfo + '/' + id+ '/' + id2, { headers: this.header })
  }

  getInsurerClient(id: any) {
    this.token = localStorage.getItem('token');
    this.header = new HttpHeaders({
      Authorization: 'Bearer ' + this.token,
      Accept: '*/*',
    });
    return this.http.get(this._getInsurerClients + '/' + id, { headers: this.header })
  }

  addInsurerClient(data : any) {
    this.token = localStorage.getItem('token');
    this.header = new HttpHeaders({
      Authorization: 'Bearer ' + this.token,
      Accept: '*/*',
    });
    return this.http.post(this._addInsurerClient, data, { headers: this.header })
  }

  updateInsurerClient(id:any, data:any){
    this.token = localStorage.getItem('token');
    this.header = new HttpHeaders({
      Authorization: 'Bearer ' + this.token,
      Accept: '*/*',
    });
    return this.http.patch(this._updateInsurerClient + '/' + id, data, { headers: this.header });
  }
}
